import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=fd01b87e&scoped=true&"
import script from "./ProviderList.vue?vue&type=script&lang=ts&"
export * from "./ProviderList.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderList.vue?vue&type=style&index=0&id=fd01b87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01b87e",
  null
  
)

export default component.exports